import Typography from "@portal/components/atoms/v2/typography";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { FormatAmount } from "@portal/helpers";
import { IEffectCostsProps } from "../types";

export const EffectCosts = ({ title, isDefaultLanguage, totalValueAfterCost, portfolioValue }: IEffectCostsProps) => {
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  return (
    <div className="flex flex-col my-3 p-3 border dark:border-blueBorderDark bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark rounded-md">
      <div className="flex w-full flex-row justify-between">
        <Typography variant="Bold">{title}</Typography>
        <Typography variant="Bold">{texts.PAGE_15_PRICE}</Typography>
      </div>
      <div className="flex w-full flex-row justify-between mt-1 mb-2 border-b">
        <Typography>{texts.PAGE_15_EXPECTED_VALUE}</Typography>
        <Typography>{FormatAmount(totalValueAfterCost)},-</Typography>
      </div>
      <div className="flex w-full flex-row justify-between">
        <Typography>{texts.PAGE_15_EXPECTED_VALUE_BEFORE_COST}</Typography>
        <Typography>{FormatAmount(portfolioValue)},-</Typography>
      </div>
    </div>
  );
};
